export function matchSideComments() {
  throw new Error('matchSideComments called on the client!');
}
